document.addEventListener('DOMContentLoaded', () => {
  initFooterTypewriters();
});

document.addEventListener('shopify:section:load', (event) => {
  initFooterTypewriters(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  initFooterTypewriters(event.target);
});

function initFooterTypewriters(root = document) {
  let typewriters = [];

  if (root.classList?.contains('footer-typewriter')) {
    typewriters = [root];
  } else {
    typewriters = Array.from(
      root.querySelectorAll('.footer-typewriter')
    );
  }

  typewriters.forEach((typewriter) => {
    if (typewriter.dataset.initialized === 'true') return;

    const textElement = typewriter.querySelector(
      '.footer-typewriter__text'
    );

    if (!textElement) return;
    const texts = [
      textElement.getAttribute('data-text-1'),
      textElement.getAttribute('data-text-2'),
      textElement.getAttribute('data-text-3')
    ].filter((text) => {
      return typeof text === 'string' && text.trim() !== '';
    });

    if (!texts.length) return;
    typewriter.dataset.initialized = 'true';

    const typeSpeed = getNumber(
      typewriter.dataset.typeSpeed,
      120
    );

    const deleteSpeed = getNumber(
      typewriter.dataset.deleteSpeed,
      80
    );

    const displayDelay = getNumber(
      typewriter.dataset.displayDelay,
      1500
    );

    const nextDelay = getNumber(
      typewriter.dataset.nextDelay,
      500
    );

    let textIndex = 0;
    let characterIndex = 0;
    let isDeleting = false;
    let timerId = null;

    function updateTypewriter() {
      if (!document.documentElement.contains(typewriter)) {
        clearTimeout(timerId);
        return;
      }

      const currentText = texts[textIndex];
      const characters = Array.from(currentText);

      if (!isDeleting) {
        characterIndex += 1;

        textElement.textContent = characters
          .slice(0, characterIndex)
          .join('');

        if (characterIndex >= characters.length) {
          isDeleting = true;

          timerId = setTimeout(
            updateTypewriter,
            displayDelay
          );

          return;
        }

        timerId = setTimeout(
          updateTypewriter,
          typeSpeed
        );

        return;
      }

      characterIndex -= 1;

      textElement.textContent = characters
        .slice(0, characterIndex)
        .join('');

      if (characterIndex <= 0) {
        characterIndex = 0;
        isDeleting = false;
        textIndex = (textIndex + 1) % texts.length;

        timerId = setTimeout(
          updateTypewriter,
          nextDelay
        );

        return;
      }

      timerId = setTimeout(
        updateTypewriter,
        deleteSpeed
      );
    }

    updateTypewriter();
  });
}

function getNumber(value, fallback) {
  const number = Number.parseInt(value, 10);

  return Number.isNaN(number)
    ? fallback
    : number;
}

document.addEventListener('DOMContentLoaded', () => {

  const accordions =
    document.querySelectorAll('.js-accordion');

  accordions.forEach((accordion) => {

    const content =
      accordion.nextElementSibling;

    if (
      !content ||
      !content.classList.contains(
        'footer-block__details-content'
      )
    ) {
      return;
    }

    // デフォルトは開いた状態
    content.style.maxHeight =
      `${content.scrollHeight}px`;

    accordion.setAttribute(
      'aria-expanded',
      'true'
    );

    accordion.addEventListener(
      'click',
      () => {

        const isClose =
          accordion.classList.contains(
            'is-close'
          );

        if (isClose) {

          // 開く
          accordion.classList.remove(
            'is-close'
          );

          content.classList.remove(
            'is-close'
          );

          content.style.maxHeight =
            `${content.scrollHeight}px`;

          accordion.setAttribute(
            'aria-expanded',
            'true'
          );

        } else {

          // 閉じる
          accordion.classList.add(
            'is-close'
          );

          content.classList.add(
            'is-close'
          );

          content.style.maxHeight = '0px';

          accordion.setAttribute(
            'aria-expanded',
            'false'
          );

        }

      }
    );

  });

});

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordion details');

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector(
      '.footer-block__details-content'
    );

    if (!summary || !content) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.classList.contains('is-animating')) {
        return;
      }

      details.classList.add('is-animating');

      if (details.open) {
        closeAccordion(details, summary, content);
      } else {
        openAccordion(details, summary, content);
      }
    });
  });

  function openAccordion(details, summary, content) {
    details.open = true;

    const startHeight = summary.offsetHeight;
    const endHeight =
      summary.offsetHeight +
      content.scrollHeight;

    details.style.height = `${startHeight}px`;

    requestAnimationFrame(() => {
      details.style.transition =
        'height 0.3s ease';

      details.style.height =
        `${endHeight}px`;
    });

    details.addEventListener(
      'transitionend',
      () => {
        details.style.height = '';
        details.style.transition = '';
        details.classList.remove('is-animating');
      },
      { once: true }
    );
  }

  function closeAccordion(details, summary, content) {
    const startHeight = details.offsetHeight;
    const endHeight = summary.offsetHeight;

    details.style.height = `${startHeight}px`;

    requestAnimationFrame(() => {
      details.style.transition =
        'height 0.3s ease';

      details.style.height =
        `${endHeight}px`;
    });

    details.addEventListener(
      'transitionend',
      () => {
        details.open = false;

        details.style.height = '';
        details.style.transition = '';
        details.classList.remove('is-animating');
      },
      { once: true }
    );
  }
});